import React, { FC } from 'react';
import classNames from 'classnames';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';
import styles from './keyword_chip.module.scss';

type Props = {
  item: string;
  selected?: boolean;
  onClick: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
};

export const KeywordChip: FC<Props> = ({ item, onClick, selected }) => {
  return (
    <span
      onClick={onClick}
      className={classNames(styles.chip, selected && styles.selected)}
      title={item}
    >
      <span className={styles.label}>{item}</span>
      {selected && (
        <button className={styles.close} type="button">
          <MaterialIcon name="close" />
        </button>
      )}
    </span>
  );
};
